






























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Types from '../../mini'
import { env } from '@ivy/fts/envInfo/envInfo'
import ivyPlayer from '../../../../commons/ivyPlayer.vue'
import { convertPxToVw } from '../../utils'

@Component({
  components: {
    ivyPlayer,
  },
})
export default class Video extends Vue {
  @Prop() data: Types.VideoComp
  @Prop() uploadEvent: any
  @Prop({ default: () => {} }) config: any
  vip_config: any = null
  playStatus: boolean = false
  videoClass: string = 'one-line'
  newTime: any
  emptyCarton: any = [
    {
      id: 'empty',
      actual_play_count: 0,
      duration: 0,
      pic_url: require('../../images/pic-one.png'),
      title: '动画视频名称，最多显示2行',
    },
  ]
  publishedCartons: any = []
  @Watch('data.videoCartoon.videoInfo')
  async getPubCartoons() {
    if (this.config && this.config.vip_config) {
      this.vip_config = this.config.vip_config
    }
    let video_ids = this.data.videoCartoon.videoInfo.map(video => video.id)
    let conf = {
      disableLoading: true,
      disableAlert: true,
    }
    if (video_ids && video_ids.length) {
      let { data } = await this.$axios.post(
        '/api/audios/resource/video/videosById',
        {
          ids: video_ids,
          ...conf,
        }
      )
      if (!data && !data.length) return
      this.publishedCartons = data
    } else {
      this.publishedCartons = []
    }
  }
  get compCustomStyle() {
    return {
      padding: `0 ${convertPxToVw(this.data.videoCustom.compMargin)}vw`,
      background: this.data.videoCustom.bgColor,
    }
  }
  get noticeStyle() {
    return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.videoCartoon.radius}px 0px 10px`
  }
  get compCartoonStyle() {
    return {
      padding: `0 ${convertPxToVw(this.data.videoCartoon.compMargin)}vw`,
      background: this.data.videoCartoon.bgColor,
      'margin-left': `-${convertPxToVw(this.data.videoCartoon.spacing / 2)}vw`,
      'margin-right': `-${convertPxToVw(this.data.videoCartoon.spacing / 2)}vw`,
    }
  }
  get whiteStyle() {
    if (this.canShowWhite) {
      return {
        background: this.data.whiteCard ? '#fff' : '#f5f5f6',
        padding: '5px',
        paddingTop: '10px',
      }
    }
    return {}
  }

  get canShowWhite() {
    return this.data.showType === 'cartoon'
  }
  get videoBoxStyle() {
    if (this.canShowWhite) {
      if (this.data.videoCartoon.whiteCard) {
        return {
          'border-radius': this.data.videoCartoon.radius + 'px',
          margin: `${convertPxToVw(this.data.videoCartoon.spacing / 2)}vw`,
          background: '#fff',
          padding: '8px',
        }
      } else {
        return {
          'border-radius': this.data.videoCartoon.radius + 'px',
          margin: `${convertPxToVw(this.data.videoCartoon.spacing / 2)}vw`,
          padding: '0px',
        }
      }
    } else {
      return {
        'border-radius': this.data.videoCartoon.radius + 'px',
        margin: `${convertPxToVw(this.data.videoCartoon.spacing / 2)}vw`,
      }
    }
  }
  get detailStyle() {
    return {
      height:
        this.data.videoCartoon.lineRule === 'one'
          ? `${convertPxToVw(168)}vw`
          : `${convertPxToVw(100)}vw`,
      'border-radius': this.data.videoCartoon.radius + 'px',
    }
  }
  get coverStyle() {
    return {
      'border-radius': this.data.videoCartoon.radius + 'px',
      'object-fit': this.data.videoCartoon.filling,
    }
  }
  get videoDescStyle() {
    return {
      'text-align': this.data.videoCartoon.fontAlign,
      'font-size': this.data.videoCartoon.lineRule === 'one' ? '16px' : '14px',
      'font-weight': this.data.videoCartoon.fontWeight,
    }
  }
  get hasCustomVideo() {
    return (
      this.data.showType === 'custom' &&
      this.data.videoCustom.videoInfo &&
      this.data.videoCustom.videoInfo.url
    )
  }
  get hasCartonVideo() {
    return (
      this.data.showType === 'cartoon' &&
      this.data.videoCartoon.videoInfo &&
      this.data.videoCartoon.videoInfo.length > 0
    )
  }
  get videoList() {
    return this.hasCartonVideo ? this.publishedCartons : this.emptyCarton
  }
  @Watch('data.videoCartoon.lineRule') // 排列规则变化,多行
  templateChange(newV) {
    this.videoClass = newV + '-line'
  }
  formatPlayCount(count) {
    if (+count >= 10000) {
      return `${(+count / 10000).toFixed(1)}万`
    }
    return count
  }
  catchHandler() {
    console.log('捕获了点击时间')
  }
  formatTime(time) {
    let tt: number = Math.floor(+time)
    let minute: number = Math.floor(tt / 60)
    let second: number = tt % 60
    return `${minute.toString().padStart(2, '0')}:${second
      .toString()
      .padStart(2, '0')}`
  }
  async playVideo() {
    // 微页面组件内容点击埋点
    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName: this.data.videoCustom.videoInfo.name,
        JumpType: '动画详情',
        JumpContentName: '',
        JumpContentID: '',
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        ['p4', 'JumpType_JumpContentID_JumpContentName'],
      ]
    )
    // 播放视频
    this.playStatus = true
    let media = (this.$refs as any).mediaPlayer
    media.play()
  }
  closeVideo() {
    // 关闭播放
    this.newTime = new Date().getTime()
  }
  playEnd() {
    this.playStatus = false
    this.newTime = new Date().getTime()
    let refM = (this.$refs as any).mediaPlayer
    refM.playOnce = false
  }

  async playCartoonVideo(item) {
    if (isNaN(+item.id)) return
    // 微页面组件内容点击埋点
    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName: item.title,
        JumpType: '动画详情',
        JumpContentName: item.title,
        JumpContentID: item.id,
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        ['p4', 'JumpType_JumpContentID_JumpContentName'],
      ]
    )
    let conf = env.getParams('video', item.id)
    env.commonJump(conf.path, conf.params, { showCancelButton: true })
  }
  created() {
    this.videoClass = this.data.videoCartoon.lineRule + '-line'
    if (this.data.showType === 'cartoon') {
      this.getPubCartoons()
    }
  }

  get playIconStyle() {
    return {
      width: this.data.videoCartoon.lineRule === 'one' ? '48px' : '33px',
      height: this.data.videoCartoon.lineRule === 'one' ? '48px' : '33px',
    }
  }
}
